import { createFileRoute } from "@tanstack/react-router";
import { routeOptions } from "@/pages/pricing";
import { withAlternates } from "@/lib/route-i18n";

export const Route = createFileRoute("/pricing")(withAlternates(routeOptions, "/pricing"));
